namespace $ {
	
	export function $mol_test_complete() {
	}
	
}
